import { AppText } from '@zippeditoolsjs/ui-web';

// Per-app greeting resolved by heimdal-api from the app_id in the URL.
// This is the surface below the sidebar breakpoint, where the sidebar is
// hidden; from there up LoginSidebar draws the same greeting with its
// typewriter. LoginLayout mounts exactly one of the two, so they never render
// together.
// Caption rather than a heading: down here it sits above the form's own
// welcome + subtitle pair, so it names the app the user is signing in to
// without competing with them for the top of the hierarchy.
// Renders nothing when there is no message: an unregistered app, a request
// still in flight or a failed one all leave the screen exactly as it is.
export default function WelcomeMessage({ message }) {
  if (!message) {
    return null;
  }

  return (
    <AppText variant="bodySmall" as="p">
      {message}
    </AppText>
  );
}
